import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Holds the draft for an item return request
  itemReturnRequestDraft: {
    orderItemId: null,
    fulfillmentGroupId: null,
    productId: null, 
    productName: '', // For display
    reason: '',
    quantity: 1,
    comments: '',
    // images: [], // For uploading images related to the return request
  },
  // Holds the draft for a rental-to-purchase request
  rentalToPurchaseRequestDraft: {
    orderItemId: null,
    fulfillmentGroupId: null,
    productId: null,
    productName: '',
    messageToMerchant: '',
  },
  // Could also store lists of fetched requests if not relying solely on RTK Query cache for display
  // myRequests: [],
  // merchantRequests: [],
  // activeRequestForm: null, // e.g., 'custom_rental', 'item_return' to control UI
  loading: false,
  error: null,
};

const requestSlice = createSlice({
  name: 'request',
  initialState,
  reducers: {
    // Update draft for item return request
    updateItemReturnRequestDraft: (state, action) => {
      state.itemReturnRequestDraft = { ...state.itemReturnRequestDraft, ...action.payload };
    },
    clearItemReturnRequestDraft: (state) => {
      state.itemReturnRequestDraft = initialState.itemReturnRequestDraft;
    },

    // Update draft for rental-to-purchase request
    updateRentalToPurchaseRequestDraft: (state, action) => {
      state.rentalToPurchaseRequestDraft = { ...state.rentalToPurchaseRequestDraft, ...action.payload };
    },
    clearRentalToPurchaseRequestDraft: (state) => {
      state.rentalToPurchaseRequestDraft = initialState.rentalToPurchaseRequestDraft;
    },
    
    // Example: set which request form is active if managing multiple modal forms
    // setActiveRequestForm: (state, action) => {
    //   state.activeRequestForm = action.payload; // payload could be 'custom_rental', 'item_return', or null
    // },

    // Potentially handle pending/fulfilled/rejected states from API calls if not solely managed by components using hooks
    // requestPending: (state) => {
    //   state.loading = true;
    //   state.error = null;
    // },
    // requestSuccess: (state, action) => {
    //   state.loading = false;
    //   // Potentially update stored requests here, e.g., state.myRequests.push(action.payload);
    // },
    // requestFailed: (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload;
    // },
  },
  // Extra reducers can be added here to listen to actions from requestApi if needed,
  // for example, to clear drafts upon successful submission from the API call itself.
  // extraReducers: (builder) => {
  //   builder
  //     .addMatcher(
  //       requestApi.endpoints.submitRequest.matchFulfilled,
  //       (state, action) => {
  //         // Assuming the requestType is part of the original args or response
  //         // This is pseudo-code, actual implementation depends on RTK query structure
  //         if (action.meta.arg.originalArgs.requestType === 'custom_rental_quote') {
  //           state.customRentalQuoteDraft = initialState.customRentalQuoteDraft;
  //         }
  //         if (action.meta.arg.originalArgs.requestType === 'item_return') {
  //            state.itemReturnRequestDraft = initialState.itemReturnRequestDraft;
  //         }
  //       }
  //     );
  // },
});

export const {
  updateItemReturnRequestDraft,
  clearItemReturnRequestDraft,
  updateRentalToPurchaseRequestDraft,
  clearRentalToPurchaseRequestDraft,
  // setActiveRequestForm,
  // requestPending,
  // requestSuccess,
  // requestFailed,
} = requestSlice.actions;

export default requestSlice.reducer; 